import {
  GET_REFERRAL_INFO_REQUEST,
  GET_REFERRAL_INFO_SUCCESS,
  GET_REFERRAL_INFO_FAILURE,
} from '../types';

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: false,
  referralUrl: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_REFERRAL_INFO_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_REFERRAL_INFO_SUCCESS:
      return {
        isLoading: false,
        isLoaded: true,
        error: false,
        referralUrl: action.payload?.referralUrl,
      };
    case GET_REFERRAL_INFO_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: true,
      };
    default:
      return state;
  }
};
